import React,{useState,useEffect} from 'react';
import { Colors } from '../../../../Tenants';
import "./HomeOwnerOnboardingDashboard.scss";
import "./Media.scss";
import { selectAuthenticatedUser } from '../../../../store/selectors/auth';
import FeedBack from  '../../../../components/FeedBack';
import { connect } from "react-redux";
const FaqsList = ({
    suiteOnBoardingFAQs,
    selectedFaqsId,
    handleSelectFaqs,user
}) => {
  const [feedBackReportPopup,setFeedBackReportPopup]=useState(false);
  var dashboardURL=window.location.href;
    useEffect(() => {
      if(user && user.roles && user.roles.length > 0 && (user.roles[0].role.name === "Home Owner") && dashboardURL.search('app/dashboard')>-1){
          let isfeedBackReportPopup = localStorage.getItem('IsHomerNavigatFromFeedBackTemplate')
          if(isfeedBackReportPopup!==undefined &&  isfeedBackReportPopup!==null && isfeedBackReportPopup!=''){
            setFeedBackReportPopup(true);
          }
        }
    } , []);
    return (
        <div className="mainRow mt-20">
          <div className="checklist">
            <h2>FAQ</h2>
            {suiteOnBoardingFAQs.map((faq) => {
          let faqId = selectedFaqsId.filter(
            (fId) => fId === faq.id
          )[0];
          return (
            <div
              className="cardFaq"
              onClick={() => handleSelectFaqs(faq.id)}
            >
              <a>
                {faqId ? (
            <svg
              width="17"
              height="3"
              viewBox="0 0 17 3"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 1.5H8.5H1"
                stroke={Colors.svgColor}
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
                ) : (
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.5 16V8.5M8.5 8.5V1M8.5 8.5H16M8.5 8.5H1"
                stroke={Colors.svgColor}
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
                )}
                {faq.name}{" "}
              </a>
              {faqId ? (
                <div className="faqContent">{faq.description}</div>
              ) : null}
            </div>
          );
        })
            }
          </div>
          {
           feedBackReportPopup && <FeedBack/>
          }
        </div>
    )
}
const mapStateToProps = (state) => {
  return {
     user:selectAuthenticatedUser(state)
  };
};
export default connect(mapStateToProps) (FaqsList);
